var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8C0.5 3.85786 3.85786 0.5 8 0.5Z",
    fill: "white",
    stroke: "url(#paint0_linear_20603_refresh)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9531 5.98927L10.5199 5.48533C10.1526 5.09956 9.71067 4.79256 9.22097 4.583C8.73127 4.37345 8.20406 4.26573 7.67141 4.26639C5.4973 4.26639 3.7334 6.03029 3.7334 8.2044C3.7334 10.3785 5.4973 12.1424 7.67141 12.1424C8.48588 12.1424 9.28032 11.8899 9.94539 11.4197C10.6105 10.9496 11.1135 10.2849 11.3852 9.51707",
    stroke: "url(#paint0_linear_20603_refresh)",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2637 4.3589V7.46726C12.2637 7.48902 12.2551 7.50989 12.2397 7.52527C12.2243 7.54066 12.2034 7.5493 12.1817 7.5493H9.07332C9.05708 7.54932 9.04121 7.54451 9.0277 7.5355C9.0142 7.52648 9.00367 7.51367 8.99746 7.49867C8.99124 7.48367 8.98962 7.46716 8.99279 7.45124C8.99596 7.43531 9.00379 7.42069 9.01527 7.40922L12.1236 4.30086C12.1351 4.28937 12.1497 4.28155 12.1657 4.27837C12.1816 4.2752 12.1981 4.27683 12.2131 4.28304C12.2281 4.28926 12.2409 4.29978 12.2499 4.31329C12.2589 4.32679 12.2637 4.34267 12.2637 4.3589Z",
    fill: "url(#paint0_linear_20603_refresh)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20603_refresh",
    x1: 2.05188,
    y1: 1.2875,
    x2: 13.8048,
    y2: 13.2228,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(45 8 8)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8287,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "res/media/refresh.9577e34a96d443ee8a1e2faaa7ee6072.svg";
export { ForwardRef as ReactComponent };